import OnboardPage from './OnboardPage';

export default OnboardPage;
